export default __webpack_public_path__ + "static/media/sendGreenDisable.4bd50a46.svg";